module.exports = {
	siteName: 'help-centre',
	site: {
		mancity: {},
	},
};
